import { Button, Divider, Group, Stack, Text, TextInput, Title } from "@mantine/core";
import { useField } from "@mantine/form";
import { modals } from "@mantine/modals";
import { IconInfoCircle } from "@tabler/icons-react";
import { useState } from "react";
import { TopicParentSelect } from "shared/components/organization/topics/TopicParentSelect";
import { useCreateCategory } from "shared/graphql/topics";
import { TopicLikeFragment } from "src/gql/graphql";

export const CategoryCreateModal = ({ parentCategory }: { parentCategory: TopicLikeFragment }) => {
    const { createCategory } = useCreateCategory();
    const [parentId, setParentId] = useState(parentCategory.id);

    const title = useField({ initialValue: "", validate: (val) => (val.length < 1 ? "Enter a title" : null) });

    return (
        <Stack>
            <Stack gap="xs">
                <Group>
                    <IconInfoCircle />
                    <Title order={4}>Category Description</Title>
                </Group>
                <Text>
                    You can use categories to organize and group topics in the system. You cannot send messages to a category without any
                    topics.
                </Text>
            </Stack>
            <TextInput label="Title" required {...title.getInputProps()} />
            <TopicParentSelect parentId={parentId} setParentId={setParentId} />
            <Divider />
            <Button
                w="100%"
                onClick={() => {
                    createCategory({ title: title.getValue(), parent: parentId });
                    modals.closeAll();
                }}
            >
                Create
            </Button>
        </Stack>
    );
};
